import script from "./ProjectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectForm.vue?vue&type=script&setup=true&lang=js"

import "./ProjectForm.vue?vue&type=style&index=0&id=5ed9db9e&lang=scss"

const __exports__ = script;

export default __exports__